/* eslint-disable @typescript-eslint/no-explicit-any */
import { IUserData } from '../user/user-data.interface';
import { apiV2Instance } from '../../lib/api-v2.client';

interface IUserAuthResponse {
  status: 'success' | 'error';
  message: string;
  error?: string;
  token: string;
  // eslint-disable-next-line camelcase
  id_token?: string;
  'un-read': number;
  result: {
    diffDays: number;
    isRegistered: boolean;
    user: {
      _id: string;
    } & Omit<IUserData, 'id'>;
  };
}

export interface IUserAuthData {
  token: string;
  idToken?: string;
  user: {
    diffDays: number;
    isRegistered: boolean;
  } & IUserData;
}

export class AuthService {
  private allowedSources = ['quickcam', 'quickmemecoin', 'cryptobullsvip', 'quickcam_website', 'quickcam_android', 'quickcam_ios'];

  login(
    code: string,
    redirectUrl: string,
    refCode: string,
  ): Promise<IUserAuthData> {
    const url = new URL(redirectUrl);
    const signUpSource = url.searchParams.get('signUpSource');

    console.log('signUpSource', signUpSource);

    // // ✅ Validate only if signUpSource exists
    // if (signUpSource && !this.allowedSources.includes(signUpSource)) {
    //   throw new Error('Unknown signUpSource');
    // }

    return apiV2Instance
      .post('/auth/login', {
        code,
        redirect_uri: redirectUrl,
        platformType: 'web',
        refCode,
      })
      .then((response: { data: IUserAuthResponse }) => {
        const { data } = response;
        const { result, token, status, message } = data;
        // eslint-disable-next-line camelcase
        const idToken = data.id_token;

        if (status === 'error') {
          throw new Error(message);
        }

        const { user, ...restResult } = result;
        const { _id: id, userStateFlags, ...restUser } = user;
        userStateFlags.sort((a, b) => (a.stateCode < b.stateCode ? -1 : 1));

        return {
          user: {
            id,
            userStateFlags,
            ...restResult,
            ...restUser,
          },
          token,
          idToken,
        };
      })
      .finally(() => {
        localStorage.removeItem('redirect_uri');
      });
  }

  logout() {
    return apiV2Instance.post('/auth/logout').then(response => response.data);
  }

  async addUsers(payload: any) {
    const response = await apiV2Instance.post(
      '/auth/keycloak/addUser',
      payload,
    );
    return response.data;
  }
}
